var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[(_vm.step === 1)?_c('ScanTicketComponent'):_c('DetailTicketComponent',{attrs:{"dataSource":_vm.dataDetail,"ticketId":_vm.ticketId,"ticketType":_vm.ticketType,"detailByScanner":_vm.detailByScanner}}),(_vm.useNewReprint)?_c('ReprintStatusDialog'):_c('ReprintDialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }